module.exports = __webpack_public_path__ + "img/Animation.ecd2119d.gif";